<div class="content">
    <div class="content-panel">
        <div class="d-flex justify-content-between flex-start p-3">
            <p-button class="export" label="{{ 'Exporter les opérateurs' | translate }}" (click)="exporterOperateurs()" (keydown.enter)="exporterOperateurs()"></p-button>
            <button class="btn btn-outline-primary d-flex align-items-center gap-2" (click)="openColumnVisibilityModal()">
                <fa-icon icon="columns"></fa-icon>
                <span>{{ 'label.colonnes' | translate }}</span>
                <span class="badge bg-primary text-white ms-2">{{ modalService.getVisibleColumnCount(columns) }} / {{ columns.length }}</span>
            </button>
        </div>

        <!-- Tableau -->
        @if (isResult && operateurs.length > 0) {
            <div >
                {{ dt?.filteredValue?.length ?? operateurs.length }}
                / {{ operateurs.length }}
            </div>
            <p-table
                #dt
                [value]="operateurs"
                [paginator]="true"
                [rows]="30"
                [scrollable]="true"
                scrollHeight="calc(100vh - 250px)">

                <ng-template pTemplate="header">
                    <tr>
                        @for (col of columns; track col) {
                            <th scope="col" [pSortableColumn]="col.field" [hidden]="!col.visible" [style.width]="col.width">
                                {{ col.label | translate }}
                                <p-sortIcon [field]="col.field" />
                                <p-columnFilter type="{{ col.filter }}" field="{{ col.field }}" display="menu" [showOperator]="false" />
                            </th>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-operateur>
                    <tr>
                        @for (col of columns; track col) {
                            <td [hidden]="!col.visible">
                                {{ operateur[col.field] }}
                            </td>
                        }
                    </tr>
                </ng-template>
            </p-table>
        } @else if (isResult && operateurs.length === 0) {
            <p class="text-center">Aucun opérateur trouvé</p>
        }
    </div>
</div>

<app-column-visibility-modal
    [columns]="columns"
    [columnsMax]="5"
    [(visible)]="showColumnVisibilityModal"
    [STORAGE_KEY]="STORAGE_KEY"
    (columnsChange)="columns = $event">
</app-column-visibility-modal>
